<template>
  <div>
    <highcharts class="chart" :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";

import { EventBus } from "@/event-bus.js";

stockInit(Highcharts);
exportingInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

export default {
  beforeCreate() {
    fetch("../includes/queries.cfc?method=getEMprojection&categoryId=6")
      .then(resp => resp.json())
      .then(resp => {
        for (var i = 0; i < 4; i++) {
          this.chartOptions.series[0].data.push(resp.DATA[i][1]);
        }
      });
    fetch("../includes/queries.cfc?method=getEMprojection&categoryId=7")
      .then(resp => resp.json())
      .then(resp => {
        for (var i = 0; i < 4; i++) {
          // console.log(i);
          //console.log(resp.DATA[i][1]);
          this.chartOptions.series[1].data.push(resp.DATA[i][1]);
        }
      });
    fetch("../includes/queries.cfc?method=getEMprojection&categoryId=23")
      .then(resp => resp.json())
      .then(resp => {
        for (var i = 0; i < 4; i++) {
          this.chartOptions.series[2].data.push(resp.DATA[i][1]);
        }
      });
    fetch("../includes/queries.cfc?method=getEMprojection&categoryId=6")
      .then(resp => resp.json())
      .then(resp => {
        for (var i = 0; i < 4; i++) {
          this.chartOptions.series[3].data.push(resp.DATA[i][1]);
        }
      });
  },
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    highcharts: Chart
  },

  created() {
    EventBus.$on("btn-clicked", data => {
      this.chartOptions.series[0].data = data.newData;
    });
  },

  data() {
    return {
      chartOptions: {
        chart: {
          type: "column"
        },
        title: {
          text: "Projected Emissions from the Energy Sector"
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: ["2020", "2030", "2040", "2050"]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Non-CO₂ Emissions (MtCO₂e)"
          }
        },

        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            "{series.name}: {point.y:,.0f}<br/>Total: {point.stackTotal:,.0f}"
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                return Highcharts.numberFormat(this.y, 0);
              }
            }
          }
        },
        series: [
          {
            name: "Coal Mining",
            data: []
          },
          {
            name: "Natural Gas and Oil Systems",
            data: []
          },
          {
            name: "Combustion of Fossil Fuels and Biomass",
            data: []
          },
          {
            name: "Other Energy",
            data: []
          }
        ]
      }
    };
  }
};
</script>
